import styled from "styled-components";

interface NavigationButtonProps {
  position: "left" | "right";
}

interface ChannelCardProps {
  isActive: boolean;
}

export const CarouselContainer = styled.div`
  position: relative;
`;

export const NavigationButton = styled.button<NavigationButtonProps>`
  position: absolute;
  ${props => props.position}: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 8px;
  border: none;
  border-radius: ${props => props.position === "left" ? "0 4px 4px 0" : "4px 0 0 4px"};
  cursor: pointer;
  transition: background-color 0.2s;

  svg {
    width: 24px;
    height: 24px;
    color: white;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;

export const ChannelCard = styled.div<ChannelCardProps>`
  cursor: pointer;
  width: 100%;
  padding: 8px;
  border: ${props => props.isActive ? "2px solid #dc2626" : "1px solid #d1d5db"};
  border-radius: 6px;
  transition: all 0.3s;
  background-color: rgba(0, 0, 0, 0.6);

  &:hover {
    border-color: #fca5a5;
  }
`;

export const ChannelLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
`;

export const ChannelLogo = styled.img`
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
`; 